'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('ipld-dag-pb'),
    DAGLink = _require.DAGLink,
    DAGNode = _require.DAGNode;

var CID = require('cids');

var log = require('debug')('ipfs:mfs:core:utils:add-link');

var UnixFS = require('ipfs-unixfs');

var DirSharded = require('ipfs-unixfs-importer/src/dir-sharded');

var _require2 = require('./hamt-utils'),
    updateHamtDirectory = _require2.updateHamtDirectory,
    recreateHamtLevel = _require2.recreateHamtLevel,
    createShard = _require2.createShard,
    toPrefix = _require2.toPrefix,
    addLinksToHamtBucket = _require2.addLinksToHamtBucket;

var errCode = require('err-code');

var mc = require('multicodec');

var mh = require('multihashes');

var last = require('it-last');

var addLink = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, options) {
    var meta;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!options.parentCid && !options.parent)) {
              _context.next = 2;
              break;
            }

            throw errCode(new Error('No parent node or CID passed to addLink'), 'EINVALIDPARENT');

          case 2:
            if (!(options.parentCid && !CID.isCID(options.parentCid))) {
              _context.next = 4;
              break;
            }

            throw errCode(new Error('Invalid CID passed to addLink'), 'EINVALIDPARENTCID');

          case 4:
            if (options.parent) {
              _context.next = 9;
              break;
            }

            log("Loading parent node ".concat(options.parentCid));
            _context.next = 8;
            return context.ipld.get(options.parentCid);

          case 8:
            options.parent = _context.sent;

          case 9:
            if (options.cid) {
              _context.next = 11;
              break;
            }

            throw errCode(new Error('No child cid passed to addLink'), 'EINVALIDCHILDCID');

          case 11:
            if (options.name) {
              _context.next = 13;
              break;
            }

            throw errCode(new Error('No child name passed to addLink'), 'EINVALIDCHILDNAME');

          case 13:
            if (!CID.isCID(options.cid)) {
              options.cid = new CID(options.cid);
            }

            if (!(!options.size && options.size !== 0)) {
              _context.next = 16;
              break;
            }

            throw errCode(new Error('No child size passed to addLink'), 'EINVALIDCHILDSIZE');

          case 16:
            meta = UnixFS.unmarshal(options.parent.Data);

            if (!(meta.type === 'hamt-sharded-directory')) {
              _context.next = 20;
              break;
            }

            log('Adding link to sharded directory');
            return _context.abrupt("return", addToShardedDirectory(context, options));

          case 20:
            if (!(options.parent.Links.length >= options.shardSplitThreshold)) {
              _context.next = 23;
              break;
            }

            log('Converting directory to sharded directory');
            return _context.abrupt("return", convertToShardedDirectory(context, _objectSpread(_objectSpread({}, options), {}, {
              mtime: meta.mtime,
              mode: meta.mode
            })));

          case 23:
            log("Adding ".concat(options.name, " (").concat(options.cid, ") to regular directory"));
            return _context.abrupt("return", addToDirectory(context, options));

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addLink(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var convertToShardedDirectory = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, options) {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return createShard(context, options.parent.Links.map(function (link) {
              return {
                name: link.Name,
                size: link.Tsize,
                cid: link.Hash
              };
            }).concat({
              name: options.name,
              size: options.size,
              cid: options.cid
            }), options);

          case 2:
            result = _context2.sent;
            log("Converted directory to sharded directory ".concat(result.cid));
            return _context2.abrupt("return", result);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function convertToShardedDirectory(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var addToDirectory = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, options) {
    var node, hashAlg, cid;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options.parent.rmLink(options.name);
            options.parent.addLink(new DAGLink(options.name, options.size, options.cid));
            node = UnixFS.unmarshal(options.parent.Data);

            if (node.mtime) {
              // Update mtime if previously set
              node.mtime = new Date();
              options.parent = new DAGNode(node.marshal(), options.parent.Links);
            }

            hashAlg = mh.names[options.hashAlg]; // Persist the new parent DAGNode

            _context3.next = 7;
            return context.ipld.put(options.parent, mc.DAG_PB, {
              cidVersion: options.cidVersion,
              hashAlg: hashAlg,
              onlyHash: !options.flush
            });

          case 7:
            cid = _context3.sent;
            return _context3.abrupt("return", {
              node: options.parent,
              cid: cid,
              size: options.parent.size
            });

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function addToDirectory(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

var addToShardedDirectory = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, options) {
    var _yield$addFileToShard, shard, path, result, node, oldLink, newLink;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return addFileToShardedDirectory(context, options);

          case 2:
            _yield$addFileToShard = _context4.sent;
            shard = _yield$addFileToShard.shard;
            path = _yield$addFileToShard.path;
            _context4.next = 7;
            return last(shard.flush('', context.block));

          case 7:
            result = _context4.sent;
            _context4.next = 10;
            return context.ipld.get(result.cid);

          case 10:
            node = _context4.sent;
            // we have written out the shard, but only one sub-shard will have been written so replace it in the original shard
            oldLink = options.parent.Links.find(function (link) {
              return link.Name.substring(0, 2) === path[0].prefix;
            });
            newLink = node.Links.find(function (link) {
              return link.Name.substring(0, 2) === path[0].prefix;
            });

            if (oldLink) {
              options.parent.rmLink(oldLink.Name);
            }

            options.parent.addLink(newLink);
            return _context4.abrupt("return", updateHamtDirectory(context, options.parent.Links, path[0].bucket, options));

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function addToShardedDirectory(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();

var addFileToShardedDirectory = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(context, options) {
    var file, rootBucket, node, shard, position, path, index, _loop, _ret;

    return _regeneratorRuntime.wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            file = {
              name: options.name,
              cid: options.cid,
              size: options.size
            }; // start at the root bucket and descend, loading nodes as we go

            _context6.next = 3;
            return recreateHamtLevel(options.parent.Links);

          case 3:
            rootBucket = _context6.sent;
            node = UnixFS.unmarshal(options.parent.Data);
            shard = new DirSharded({
              root: true,
              dir: true,
              parent: null,
              parentKey: null,
              path: '',
              dirty: true,
              flat: false,
              mode: node.mode
            }, options);
            shard._bucket = rootBucket;

            if (node.mtime) {
              // update mtime if previously set
              shard.mtime = new Date();
            } // load subshards until the bucket & position no longer changes


            _context6.next = 10;
            return rootBucket._findNewBucketAndPos(file.name);

          case 10:
            position = _context6.sent;
            path = toBucketPath(position);
            path[0].node = options.parent;
            index = 0;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var segment, node, link, subShard, _position, nextSegment;

              return _regeneratorRuntime.wrap(function _loop$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      segment = path[index];
                      index++;
                      node = segment.node;
                      link = node.Links.find(function (link) {
                        return link.Name.substring(0, 2) === segment.prefix;
                      });

                      if (link) {
                        _context5.next = 8;
                        break;
                      }

                      // prefix is new, file will be added to the current bucket
                      log("Link ".concat(segment.prefix).concat(file.name, " will be added"));
                      index = path.length;
                      return _context5.abrupt("return", "break");

                    case 8:
                      if (!(link.Name === "".concat(segment.prefix).concat(file.name))) {
                        _context5.next = 12;
                        break;
                      }

                      // file already existed, file will be added to the current bucket
                      log("Link ".concat(segment.prefix).concat(file.name, " will be replaced"));
                      index = path.length;
                      return _context5.abrupt("return", "break");

                    case 12:
                      if (!(link.Name.length > 2)) {
                        _context5.next = 16;
                        break;
                      }

                      // another file had the same prefix, will be replaced with a subshard
                      log("Link ".concat(link.Name, " ").concat(link.Hash, " will be replaced with a subshard"));
                      index = path.length;
                      return _context5.abrupt("return", "break");

                    case 16:
                      // load sub-shard
                      log("Found subshard ".concat(segment.prefix));
                      _context5.next = 19;
                      return context.ipld.get(link.Hash);

                    case 19:
                      subShard = _context5.sent;

                      if (path[index]) {
                        _context5.next = 29;
                        break;
                      }

                      log("Loaded new subshard ".concat(segment.prefix));
                      _context5.next = 24;
                      return recreateHamtLevel(subShard.Links, rootBucket, segment.bucket, parseInt(segment.prefix, 16));

                    case 24:
                      _context5.next = 26;
                      return rootBucket._findNewBucketAndPos(file.name);

                    case 26:
                      _position = _context5.sent;
                      path.push({
                        bucket: _position.bucket,
                        prefix: toPrefix(_position.pos),
                        node: subShard
                      });
                      return _context5.abrupt("return", "break");

                    case 29:
                      nextSegment = path[index]; // add next levels worth of links to bucket

                      _context5.next = 32;
                      return addLinksToHamtBucket(subShard.Links, nextSegment.bucket, rootBucket);

                    case 32:
                      nextSegment.node = subShard;

                    case 33:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _loop);
            });

          case 15:
            if (!(index < path.length)) {
              _context6.next = 22;
              break;
            }

            return _context6.delegateYield(_loop(), "t0", 17);

          case 17:
            _ret = _context6.t0;

            if (!(_ret === "break")) {
              _context6.next = 20;
              break;
            }

            return _context6.abrupt("break", 22);

          case 20:
            _context6.next = 15;
            break;

          case 22:
            _context6.next = 24;
            return shard._bucket.put(file.name, {
              size: file.size,
              cid: file.cid
            });

          case 24:
            return _context6.abrupt("return", {
              shard: shard,
              path: path
            });

          case 25:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee5);
  }));

  return function addFileToShardedDirectory(_x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}();

var toBucketPath = function toBucketPath(position) {
  var bucket = position.bucket;
  var positionInBucket = position.pos;
  var path = [{
    bucket: bucket,
    prefix: toPrefix(positionInBucket)
  }];
  bucket = position.bucket._parent;
  positionInBucket = position.bucket._posAtParent;

  while (bucket) {
    path.push({
      bucket: bucket,
      prefix: toPrefix(positionInBucket)
    });
    positionInBucket = bucket._posAtParent;
    bucket = bucket._parent;
  }

  path.reverse();
  return path;
};

module.exports = addLink;